import { Button } from '@Sage/hoi-poi-ui';
import { getLiteral } from 'utils/getLiteral';
import { publish } from 'lib/EventBuser';
import { OPEN_CREATE_SENDER_MODAL } from './constants';

export default function SenderSettingsHeader() {
    const handleCreateClick = () => {
        publish(OPEN_CREATE_SENDER_MODAL);
    };

    return (
        <div className="marketing-settings__header">
            <Button onClick={handleCreateClick}>{getLiteral('label_create_sender')}</Button>
        </div>
    );
}
